<template>
  <Main>
    <template v-slot:toolbar>
      <div class="ghostWhite">
        <div class="px-sm-10 px-md-10 px-5 pt-10 pb-4 max-content-width">
          <ToolbarTimelineQuotation
            :quotation="currentQuotation"
            :status-items="statusQuotation"
            v-if="hasQuotation"
          />
        </div>
      </div>
    </template>
    <BaseQuotationStatus
      :quotation="currentQuotation"
      v-if="hasQuotation"
      :insurance-items="insuranceItems"
    />
  </Main>
</template>
<script>
import BaseQuotationStatus from "../status_quotation_steps/BaseQuotationStatus";
import { mapActions, mapState } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
export default {
  beforeRouteLeave(to, from, next) {
    // garantir que não ficará chamando infinito o status
    // caso o usuário saia da página
    if (this.checkStatus) clearInterval(this.checkStatus);
    next();
  },
  data: () => ({
    hasQuotation: false,
    checkStatus: null,
    insuranceItems: []
  }),
  components: {
    BaseQuotationStatus
  },
  mixins: [LoadingRequest],
  created() {
    this.fetchQuotation();
  },
  computed: {
    ...mapState("quotation", [
      "currentQuotation",
      "statusQuotation",
      "statusCurrentQuotation"
    ])
  },
  methods: {
    ...mapActions("quotation", [
      "requestCurrentQuotation",
      "requestStatusCurrentQuotation"
    ]),
    fetchQuotation() {
      this.withLoading(this.requestCurrentQuotation(this.$route.params.id));
    },
    async fetchStatusQuotation() {
      await this.requestStatusCurrentQuotation(this.$route.params.id);
    }
  },
  watch: {
    currentQuotation(value) {
      this.hasQuotation = true;
      if (value.acoes?.processo?.executando_acao_em_segundo_plano) {
        let vm = this;
        this.checkStatus = setInterval(function() {
          vm.fetchStatusQuotation();
        }, 30000);
      }
    },
    statusCurrentQuotation(value) {
      if (
        value.id == "apolice_emitida" &&
        this.currentQuotation.acoes?.processo?.executando_acao_em_segundo_plano
      ) {
        clearInterval(this.checkStatus);
        this.hasQuotation = false;
        this.fetchQuotation();
      }
    }
  }
};
</script>
